import React, { PureComponent, Fragment } from 'react'

import { FormattedMessage } from '@dragonraider5/react-intl'
import { SectionTitle } from '../../components/Section'
import RegisterWelcome from './RegisterWelcome'
import RegisterForm from './RegisterForm'
import RegisterSuccess from './RegisterSuccess'
import messages from './messages';

class Register extends PureComponent {
  static defaultProps = {
    status: {}
  }

  scrollRef = React.createRef()

  componentDidUpdate(prevProps) {
    if (!prevProps.status.success && this.props.status.success) {
      this.scrollRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'start'
      })
    }
  }

  render() {
    const child = this.props.status.success ? (
      <RegisterSuccess />
    ) : (
      <Fragment>
        <RegisterWelcome />
        <RegisterForm {...this.props} />
      </Fragment>
    )

    return (
      <Fragment>
        <SectionTitle data-section='1' ref={this.scrollRef}>
          <FormattedMessage {...messages.sectionTitle} />
        </SectionTitle>
        {child}
      </Fragment>
    )
  }
}

export default Register
